import * as tslib_1 from "tslib";
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { endOfDay, mapIds, startOfDay } from '@core/utils/filters-utils';
import { isEmpty } from 'lodash';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../../../core/authentication/authentication.service";
var FilterStateManagerService = /** @class */ (function () {
    function FilterStateManagerService(router, route, authenticationService) {
        this.router = router;
        this.route = route;
        this.authenticationService = authenticationService;
        this.isFilterOn = false;
    }
    FilterStateManagerService.prototype.toQuery = function (value) {
        return {
            locationGroupId_in: mapIds(value.locationGroups),
            locationId_in: mapIds(value.locations),
            typeId_in: mapIds(value.maintenanceTypes),
            segmentId_in: mapIds(value.segments),
            companyId_in: mapIds(value.companies),
            from: startOfDay(value.openedAtGte),
            to: endOfDay(value.openedAtLte),
            scheduledAt_gte: startOfDay(value.scheduledAtGte, 'YYYY-MM-DD'),
            scheduledAt_lte: endOfDay(value.scheduledAtLte, 'YYYY-MM-DD'),
            closedAt_gte: startOfDay(value.closedAtGte),
            closedAt_lte: endOfDay(value.closedAtLte),
        };
    };
    FilterStateManagerService.prototype.clearFilters = function (filter, routeName) {
        var queryParams = this.router.routerState.snapshot.root.queryParams;
        var newQueryParams = {};
        var filters = queryParams.filters, restQueryParams = tslib_1.__rest(queryParams, ["filters"]);
        newQueryParams = restQueryParams;
        var url = this.router.serializeUrl(this.router.createUrlTree([routeName], { queryParams: tslib_1.__assign({}, newQueryParams) }));
        filter.filtersForm.patchValue(filter.defaultFilterValues);
        this.isFilterOn = false;
        this.setDataOnLocalStorage(filter, routeName);
        this.router.navigateByUrl(url);
    };
    FilterStateManagerService.prototype.getSavedData = function (filter, routeName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataFromUrl;
            return tslib_1.__generator(this, function (_a) {
                if (filter.filterForm && filter.filtersForm.invalid) {
                    return [2 /*return*/];
                }
                dataFromUrl = this.route.snapshot.queryParams;
                if (isEmpty(dataFromUrl)) {
                    this.getDataFromLocalStorage(filter, routeName);
                    this.setDataToQueryParams(filter, routeName);
                    return [2 /*return*/];
                }
                this.getDataFromUrl(filter, dataFromUrl);
                return [2 /*return*/];
            });
        });
    };
    FilterStateManagerService.prototype.setDataToQueryParams = function (filter, routeName) {
        if (filter.filterForm && filter.filtersForm.invalid) {
            return;
        }
        var userId = this.authenticationService.user.id;
        var formatedFilters = this.removeNullProperties(filter.filtersForm.value);
        var navigationQuery = this.isFilterOn ? {
            queryParams: {
                userId: userId,
                filters: this.isFilterOn ? JSON.stringify(formatedFilters) : null,
                selectedOption: this.selectedOption ? JSON.stringify(this.selectedOption) : null
            },
            queryParamsHandling: 'merge'
        } : null;
        var url = navigationQuery ? this.router.serializeUrl(this.router.createUrlTree([routeName], { queryParams: tslib_1.__assign({}, navigationQuery.queryParams) })) : routeName;
        this.router.navigateByUrl(url);
    };
    FilterStateManagerService.prototype.setDataOnLocalStorage = function (filter, routeName) {
        if (this.authenticationService && this.authenticationService.user && this.authenticationService.user.id && filter.filtersForm.valid) {
            var userId = this.authenticationService.user.id;
            var data = this.isFilterOn ? {
                userId: userId,
                filters: this.isFilterOn ? filter.filtersForm.value : null,
                selectedOption: this.selectedOption ? this.selectedOption : null
            } : null;
            localStorage.setItem(routeName, JSON.stringify(data));
        }
    };
    FilterStateManagerService.prototype.getDataFromLocalStorage = function (filter, routeName) {
        var dataFromLocalStorage = JSON.parse(localStorage.getItem(routeName));
        var isUserValidLocalStorage = dataFromLocalStorage && dataFromLocalStorage.userId === this.authenticationService.user.id;
        var savedSelectedOptionLocalStorage = dataFromLocalStorage && dataFromLocalStorage.selectedOption;
        var savedFiltersLocalStorage = dataFromLocalStorage && dataFromLocalStorage.filters;
        if (!isUserValidLocalStorage) {
            return;
        }
        if (savedSelectedOptionLocalStorage) {
            var selectedOption = savedSelectedOptionLocalStorage;
            this.selectedOption = selectedOption;
        }
        if (savedFiltersLocalStorage) {
            var formatedFilters = this.convertStringDateToMomentDate(savedFiltersLocalStorage);
            filter.filtersForm.patchValue(formatedFilters);
            this.isFilterOn = true;
        }
    };
    FilterStateManagerService.prototype.getDataFromUrl = function (filter, dataFromUrl) {
        var isUserValidUrl = dataFromUrl.userId === this.authenticationService.user.id;
        var selectedOptionFromUrl = dataFromUrl.selectedOption ? JSON.parse(dataFromUrl.selectedOption) : null;
        var filtersFromUrl = dataFromUrl.filters ? JSON.parse(dataFromUrl.filters) : null;
        if (!isUserValidUrl) {
            return;
        }
        if (selectedOptionFromUrl) {
            var selectedOption = selectedOptionFromUrl;
            this.selectedOption = selectedOption;
        }
        if (filtersFromUrl) {
            var formatedFilters = this.convertStringDateToMomentDate(filtersFromUrl);
            filter.filtersForm.patchValue(formatedFilters);
            this.isFilterOn = true;
        }
    };
    FilterStateManagerService.prototype.removeNullProperties = function (obj) {
        return Object.entries(obj)
            .filter(function (_a) {
            var _b = tslib_1.__read(_a, 2), _ = _b[0], value = _b[1];
            return value !== null;
        })
            .reduce(function (acc, _a) {
            var _b;
            var _c = tslib_1.__read(_a, 2), key = _c[0], value = _c[1];
            return (tslib_1.__assign({}, acc, (_b = {}, _b[key] = value, _b)));
        }, {});
    };
    FilterStateManagerService.prototype.convertStringDateToMomentDate = function (filtersFromUrl) {
        var keysToConvert = ['openedAtGte', 'openedAtLte', 'closedAtGte', 'closedAtLte', 'scheduledAtGte', 'scheduledAtLte'];
        keysToConvert.forEach(function (key) {
            if (filtersFromUrl[key]) {
                filtersFromUrl[key] = moment(filtersFromUrl[key]);
            }
        });
        return filtersFromUrl;
    };
    FilterStateManagerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterStateManagerService_Factory() { return new FilterStateManagerService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(i2.AuthenticationService)); }, token: FilterStateManagerService, providedIn: "root" });
    return FilterStateManagerService;
}());
export { FilterStateManagerService };
